import { TextWithEllipsis } from 'ComponentLibrary/src/piazza/text'
import { SimpleTableCell } from './SimpleTableCell'
import { tokens } from 'ComponentLibrary'
import { Box } from '@mui/material'

type SimpleTableHeadlineProps = {
    variant: 'primary' | 'secondary'
    text: string
    alignment?: 'left' | 'right'
    withPadding?: boolean
}

export function SimpleTableHeadline({ variant = 'primary', text, alignment, withPadding }: SimpleTableHeadlineProps) {
    return (
        <Box paddingTop={withPadding ? tokens.SizingSpacing200 : undefined}>
            <SimpleTableCell alignment={alignment}>
                <Box sx={{ minWidth: 0 }}>
                    <TextWithEllipsis
                        tooltipText={text}
                        typographyProps={{
                            variant: variant === 'primary' ? 'headline4' : 'headline5',
                            color: variant === 'primary' ? tokens.ColorTextBoldest : tokens.ColorTextSubtle,
                        }}
                    >
                        {text}
                    </TextWithEllipsis>
                </Box>
            </SimpleTableCell>
        </Box>
    )
}
